export enum UserRole {
  showtimes = 'API - Showtimes',
  streaming = 'API - Streaming',
  festivals = 'API - Festivals',
  community = 'API - Community Elements',
  social = 'API - Social Elements',
  uplay = 'API - uPlay'
}
